export default __webpack_public_path__ + "static/media/bpm.ebd3a450.svg";